import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import Grid from '@rezdy/components/Grid';
import Icon from '@rezdy/components/Icon';
import styled from 'styled-components';

export interface IAvatarCardProps {
    avatar: string;
    company: string;
    name: string;
    rating: number;
}

const AvatarText = styled(TextStyle)`
    margin: 0px;
`;

const AvatarImage = styled.img`
    border-radius: 24px;
`;

export const AvatarCard = (props: IAvatarCardProps) => {
    return (
        <Grid.Container colGap cols="48px 1fr">
            <Grid.Cell>
                <AvatarImage src={props.avatar} />
            </Grid.Cell>
            <Grid.Cell>
                <AvatarText weight="bold" size="small" as="div">
                    {props.name}
                </AvatarText>
                <AvatarText size="extra-small" as="div">
                    {props.company}
                </AvatarText>
                <AvatarText>
                    {[...Array(props.rating - 1)].map((e, i) => (
                        <Icon key={i} name="star-filled" color="#FFD519" />
                    ))}
                </AvatarText>
            </Grid.Cell>
        </Grid.Container>
    );
};

export default AvatarCard;
